import type { FunctionMeta, VariableMeta } from './types';

export const USER_VARIABLES: VariableMeta[] = [
  { path: 'user.id', type: 'STRING', description: 'Current user identifier', example: 'usr_alice' },
  { path: 'user.email', type: 'STRING', description: "Current user's email", example: 'alice@selfic.ai' },
  { path: 'user.roles', type: 'STRING[]', description: 'Assigned roles', example: '["admin"]' },
  { path: 'user.groups', type: 'STRING[]', description: 'Assigned groups', example: '["IT"]' },
  { path: 'user.department', type: 'STRING', description: "Current user's department", example: 'IT' },
  { path: 'user.region', type: 'STRING', description: "Current user's region", example: 'US' },
  { path: 'user.tenant_id', type: 'STRING', description: "Current user's tenant", example: 'tenant_us' },
  { path: 'user.employee_id', type: 'STRING', description: "Current user's employee id", example: 'E001' },
  { path: 'user.manager_id', type: 'STRING', description: "Current user's manager id", example: 'E000' },
  { path: 'user.attributes.clearance', type: 'STRING', description: 'Clearance attribute', example: 'high' },
  { path: 'user.descendant_employee_ids', type: 'STRING[]', description: 'Direct and indirect reports', example: '["E003","E004"]' },
];

export const REQUEST_VARIABLES: VariableMeta[] = [
  { path: 'request.channel', type: 'STRING', description: 'Request channel', example: 'mcp' },
  { path: 'request.operation', type: 'STRING', description: 'Requested operation', example: 'SELECT' },
  { path: 'request.timestamp', type: 'TIMESTAMP', description: 'Trusted request time', example: '2026-10-17T17:00:00Z' },
  { path: 'request.environment', type: 'STRING', description: 'Runtime environment', example: 'prod' },
];

export const RESOURCE_VARIABLES: VariableMeta[] = [
  { path: 'resource.vault_id', type: 'STRING', description: 'Owning WorkSpace id', example: 'spc-customer' },
  { path: 'resource.model_id', type: 'STRING', description: 'Owning data model id', example: 'mdl-customer-360' },
  { path: 'resource.asset_id', type: 'STRING', description: 'Target asset id', example: 'tbl-customer-profile' },
  { path: 'resource.classification', type: 'STRING', description: 'Asset or column classification', example: 'PII' },
  { path: 'resource.connection_type', type: 'STRING', description: 'Source connection type', example: 'snowflake' },
];

export const ALL_VARIABLES: VariableMeta[] = [...USER_VARIABLES, ...REQUEST_VARIABLES, ...RESOURCE_VARIABLES];

export const FUNCTION_REGISTRY: FunctionMeta[] = [
  { name: 'LOWER', signature: 'LOWER(value)', description: 'Lowercase a string value' },
  { name: 'UPPER', signature: 'UPPER(value)', description: 'Uppercase a string value' },
  { name: 'COALESCE', signature: 'COALESCE(a, b)', description: 'First non-null argument' },
  { name: 'STARTS_WITH', signature: 'STARTS_WITH(value, prefix)', description: 'True when value starts with prefix' },
  { name: 'ENDS_WITH', signature: 'ENDS_WITH(value, suffix)', description: 'True when value ends with suffix' },
  { name: 'CONTAINS', signature: 'CONTAINS(value, fragment)', description: 'True when value contains fragment' },
  { name: 'CURRENT_DATE', signature: 'CURRENT_DATE', description: 'Trusted current date' },
  { name: 'CURRENT_TIMESTAMP', signature: 'CURRENT_TIMESTAMP', description: 'Trusted current timestamp' },
];

export const KEYWORDS = ['AND', 'OR', 'NOT', 'IN', 'NOT IN', 'IS NULL', 'IS NOT NULL'] as const;

export function variableByPath(path: string): VariableMeta | undefined {
  const normalized = path.replace(/^\$\{|\}$/g, '');
  return ALL_VARIABLES.find((item) => item.path === normalized);
}

export function isKnownVariable(path: string): boolean {
  return Boolean(variableByPath(path));
}
